module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.64d4cf6.eot";